import { render, staticRenderFns } from "./KTCInstallmentPlanEdit.vue?vue&type=template&id=2c9ce83a&"
import script from "./KTCInstallmentPlanEdit.vue?vue&type=script&lang=js&"
export * from "./KTCInstallmentPlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports